import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyBEFGwWzijjnpP4KTKu5XsCwaj3EuXy--A",
  authDomain: "teste-react-native-9396d.firebaseapp.com",
  projectId: "teste-react-native-9396d",
  storageBucket: "teste-react-native-9396d.appspot.com",
  messagingSenderId: "784258373513",
  appId: "1:784258373513:web:6c01032644938e70273358",
  measurementId: "G-3VG0GTBKJ0"
};

// Initialize Firebase
initializeApp(firebaseConfig);
